module.exports = __webpack_public_path__ + "media/images/new_home/link-3aa0c7d2a4d7b42edcb58abdb13da0a8.svg";